
import React, {Component} from 'react';
import Pusher from "pusher-js";
import {PUSHER_CONFIG} from "../config";

import addNotification from "react-push-notification";


class Notification extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pusherClient: null,
            channel: null,
        }

    }

    componentDidMount() {

        this.state.pusherClient = new Pusher("andamebartar_key", PUSHER_CONFIG)
        let channel = this.state.pusherClient.subscribe("notification");
        this.setState({
            channel: channel
        })
        channel.bind('App\\Events\\RealTimeMessage', function (data) {
            let not = addNotification({
                title: 'اندام برتر',
                message: data.message,
                theme: 'red',
                vibrate: 2,
                native: true // when using native, your OS will handle theming.
            });
        }, this)
    }

    render() {

        return null;
    }

}

export default Notification


